import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Avatar } from '../ui/Avatar';
import { Card } from '../ui/Card';
import { Confetti } from './Confetti';
import { playSaleSound } from '../../utils/sounds';
import { formatCurrency } from '../../utils/format';
interface SaleNotificationProps {
  isOpen: boolean;
  onClose: () => void;
  sellerName: string;
  sellerAvatar: string;
  productName: string;
  value: number;
}
export function SaleNotificationPopup({
  isOpen,
  onClose,
  sellerName,
  sellerAvatar,
  productName,
  value
}: SaleNotificationProps) {
  useEffect(() => {
    if (isOpen) {
      playSaleSound();
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-158">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none" data-id="element-159">
          {/* Confetti Background */}
          <Confetti data-id="element-160" />

          {/* Rocket Animation */}
          <motion.div initial={{
        x: '-10vw',
        y: '110vh',
        rotate: 45,
        scale: 0.5
      }} animate={{
        x: '110vw',
        y: '-10vh',
        transition: {
          duration: 2.5,
          ease: 'easeOut'
        }
      }} className="fixed z-40 text-[120px] drop-shadow-2xl filter" style={{
        textShadow: '0 0 20px rgba(255,165,0,0.5)'
      }} data-id="element-161">
            🚀
          </motion.div>

          {/* Main Card */}
          <motion.div initial={{
        scale: 0.5,
        opacity: 0,
        y: 50
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.8,
        opacity: 0,
        y: -50
      }} transition={{
        type: 'spring',
        damping: 15
      }} className="pointer-events-auto" data-id="element-162">
            <Card className="w-[400px] bg-slate-900/90 backdrop-blur-xl border-2 border-primary/50 shadow-[0_0_50px_rgba(var(--primary-rgb),0.3)] p-8 text-center relative overflow-hidden" data-id="element-163">
              {/* Shine effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-white/5 via-white/10 to-transparent opacity-0 animate-pulse" data-id="element-164" />

              <motion.div initial={{
            y: -20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.2
          }} className="flex flex-col items-center gap-4" data-id="element-165">
                <div className="relative" data-id="element-166">
                  <div className="absolute -inset-4 bg-primary/20 rounded-full blur-xl animate-pulse" data-id="element-167" />
                  <Avatar src={sellerAvatar} fallback={sellerName} size="xl" className="ring-4 ring-primary shadow-2xl w-24 h-24 text-2xl" data-id="element-168" />
                  <div className="absolute -bottom-2 -right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow-lg border-2 border-slate-900" data-id="element-169">
                    +1 Venda!
                  </div>
                </div>

                <div className="space-y-1" data-id="element-170">
                  <h2 className="text-2xl font-bold text-white" data-id="element-171">Nova Venda!</h2>
                  <p className="text-lg text-primary-light font-medium" data-id="element-172">
                    {sellerName}
                  </p>
                </div>

                <div className="bg-slate-800/50 rounded-xl p-4 w-full border border-white/10" data-id="element-173">
                  <p className="text-sm text-text-muted mb-1" data-id="element-174">Vendeu</p>
                  <p className="text-lg font-semibold text-white mb-2" data-id="element-175">
                    {productName}
                  </p>
                  <div className="h-px w-full bg-white/10 mb-2" data-id="element-176" />
                  <p className="text-3xl font-bold text-green-400 drop-shadow-sm" data-id="element-177">
                    {formatCurrency(value)}
                  </p>
                </div>
              </motion.div>
            </Card>
          </motion.div>
        </div>}
    </AnimatePresence>;
}